"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _CBSFAW7Ncjs = require('../__chunks/CBSFAW7N.cjs');


var _FHIGX2EEcjs = require('../__chunks/FHIGX2EE.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function FormProvider(props = {}) {
  const store = _CBSFAW7Ncjs.useFormStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _FHIGX2EEcjs.FormContextProvider, { value: store, children: props.children });
}


exports.FormProvider = FormProvider;
